export enum PollsStatus {
  /**
   * Publicada
   */
  PUBLISHED = 'PUBLISHED',
  /**
   * Não publicada
   */
  NOT_PUBLISHED = 'NOT_PUBLISHED',
  /**
   * Rascunho
   */
  DRAFT = 'DRAFT',
  /**
   * Deletado
   */
  DELETED = 'DELETED',
}

export const translatePollsStatus = (status: PollsStatus): string => {
  switch (status) {
    case PollsStatus.PUBLISHED:
      return 'Publicado';
    case PollsStatus.NOT_PUBLISHED:
      return 'Não publicado';
    case PollsStatus.DRAFT:
      return 'Rascunho';
    default:
      return status;
  }
};

export enum PollsInteractivity {
  /**
   * Ativa
   */
  ENABLED = 'ENABLED',
  /**
   * Encerrada
   */
  CLOSED = 'CLOSED',
}

export const translatePollsInteractivity = (status: PollsInteractivity): string => {
  switch (status) {
    case PollsInteractivity.ENABLED:
      return 'Ativo';
    case PollsInteractivity.CLOSED:
      return 'Encerrado';
    default:
      return status;
  }
};

export class PollsOptions {
  uuid: string;
  option_text: string;
  votes: number;
  image_url: string;
  created_at: string;
  updated_at: string;
}

export class Polls {
  uuid: string;
  question: string;
  identifier: string;
  status: PollsStatus;
  interactivity: PollsInteractivity;
  closing_date: string | null;
  closed_at?: string | null;
  allow_multiple_votes: boolean;
  show_partial_results: boolean;
  disable_comments: boolean;
  enable_home: boolean;
  total_participants: number;
  total_comments: number;
  total_votes: number;
  poll_options: PollsOptions[];
  team_uuid?: string;
  team_name?: string;
  team_image?: string;
  created_at: string;
  updated_at: string;
}
